import React from 'react';
import PropTypes from 'prop-types';

const DocTitle = ({syncTo}) => {
    document.title = syncTo !== null && syncTo.length > 0
        ? `${syncTo} - Ncontracts`
        : 'Ncontracts';

    return (<div/>);
};

DocTitle.propTypes = {
    syncTo: PropTypes.string.isRequired
};

export default DocTitle;
